export const getShiftsInWeek = <T extends { date: string }>(
  week: { days: string[] },
  shifts: T[],
): T[] => {
  const daysInWeek = week.days.map((dateFormatted) => dateFormatted)
  return shifts.filter((shift) => daysInWeek.includes(shift.date))
}
